var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicingHead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#E7ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8217 15.0356H17.1789C16.6295 15.0356 16.1026 15.2539 15.7141 15.6424C15.3257 16.0308 15.1074 16.5577 15.1074 17.1071V39.8928C15.1074 40.4422 15.3257 40.969 15.7141 41.3575C16.1026 41.746 16.6295 41.9642 17.1789 41.9642H35.8217C36.3711 41.9642 36.898 41.746 37.2864 41.3575C37.6749 40.969 37.8931 40.4422 37.8931 39.8928V17.1071C37.8931 16.5577 37.6749 16.0308 37.2864 15.6424C36.898 15.2539 36.3711 15.0356 35.8217 15.0356Z",
    stroke: "#A3AED0",
    strokeWidth: 2.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6296 32.6429H30.8876C29.3651 32.6429 27.8633 32.2886 26.5003 31.6071C25.139 30.9234 23.6363 30.5687 22.113 30.5714H20.373M15.1074 21.25H37.8931M32.7146 31.6071C32.7146 32.4232 32.5538 33.2313 32.2415 33.9852C31.9292 34.7392 31.4715 35.4243 30.8944 36.0013C30.3174 36.5784 29.6323 37.0361 28.8784 37.3484C28.1244 37.6607 27.3164 37.8214 26.5003 37.8214C25.6842 37.8214 24.8761 37.6607 24.1222 37.3484C23.3682 37.0361 22.6832 36.5784 22.1061 36.0013C21.5291 35.4243 21.0713 34.7392 20.759 33.9852C20.4467 33.2313 20.286 32.4232 20.286 31.6071C20.286 29.959 20.9407 28.3784 22.1061 27.213C23.2715 26.0476 24.8521 25.3929 26.5003 25.3929C28.1484 25.3929 29.729 26.0476 30.8944 27.213C32.0598 28.3784 32.7146 29.959 32.7146 31.6071Z",
    stroke: "#A3AED0",
    strokeWidth: 2.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicingHead);
export default __webpack_public_path__ + "static/media/servicing-head.94666242b432cf655c08ed13990b3743.svg";
export { ForwardRef as ReactComponent };